import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { hideModal } from '../../actions/_modal'
import Modal from '../mini/Modal'
import TransparentButton from '../styled/buttons/TransparentButton'
import FlexAlignCenter from '../styled/FlexAlignCenter'
import { P2 } from '../styled/typography/typography'
import { AlertWrapper, Header, Divider } from './styles'

const OkButtonWrapper = styled(FlexAlignCenter)`
  padding-right: 29px;
  justify-content: flex-end;
`

const OkButton = styled(TransparentButton)`
  padding: 13px 41px;
  height: auto;
  color: #333;
`

const GeneralError = () => {
  const dispatch = useDispatch()
  const close = () => dispatch(hideModal())

  return (
    <Modal
      width={500}
      top={50}
      autoHeight
      allowOverflow
      closeCallback={close}
    >
      <AlertWrapper>
        <Header>Error</Header>
        <P2>
        Oops! Something went wrong. Please try again. <br/>
        Contact support if this error persists.
        </P2>
        <Divider/>
        <OkButtonWrapper>
          <OkButton onClick={close}>
            Ok
          </OkButton>
        </OkButtonWrapper>
      </AlertWrapper>
    </Modal>
  )
}

export default GeneralError
